export const focusOnRef = (ref) => {
  ref.current && ref.current.focus();
};